import PropTypes from "prop-types"
import { Wrapper, Content } from "./Grid.styles";

const Grid = ({ header, children }) => { //children is a builtin prop
    return (
        <Wrapper>
            <h1 style={{color: "#2F86A6"}}>{header}</h1>
            <Content>{children}</Content>
        </Wrapper>
    )
}

Grid.propTypes = {
    header: PropTypes.string
}

export default Grid
